export default __webpack_public_path__ + "static/media/c8.90cd2d9c.png";